import { makeStyles } from '@material-ui/core/styles';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { color } from '../../app/theme';
import { MANodeType } from '../../app/types';
import MA from './maNodeSetting/MA';
import Mask from './SettingBarMask';

const useStyles = makeStyles(
  {
    top: {
      fontSize: '17px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      letterSpacing: 'normal',
      color: color.$3,
      background: color.$9,
      textAlign: 'center',
      padding: '18px 0 21px',
    },
    bottom: {
      padding: '24px 16px',
      overflowY: 'auto',
      height: 'calc(100vh - 170px)',
    },
  },
  {
    name: 'MASettingBar',
  },
);

const MASettingBar = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { selectedNode } = useSelector(state => state.ma);
  const { data } = selectedNode || {};
  const { type } = data || {};

  const ContentComponent = useMemo(() => {
    switch (type) {
      case MANodeType.MA:
        return <MA />;
      default:
        return null;
    }
  }, [type]);

  return (
    <>
      <div className={classes.top}>{t('add-ma')}</div>
      <div id="ma-setting-bar-bottom" className={classes.bottom}>
        {ContentComponent}
      </div>
      <Mask mainId="ma-setting-bar-bottom" />
    </>
  );
};

export default MASettingBar;
